import styled from 'styled-components';

export const UrlsLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const UrlsEachinks = styled.div`
    font-size: 14px;
    color: #535766;
    display: block;
    text-decoration: underline;
    padding-bottom: 12px;
    min-height:55px;
    @media (max-width: 720px) {
    font-size: 12px;
    }
}
`;
export const Heading = styled.div`
  color: #535766;
  font-size: 16px;
  font-weight: 600;
  display: block;
  text-decoration: underline;
  padding: 10px 0px 12px;
  @media (max-width: 720px) {
    font-size: 14px;
  }
`;
export const TopHeading = styled.h2`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;
export const AnchorTagUrl = styled.a`
  display: flex;
  column-gap: 2px;
`;
export const OuterContainer = styled.div`
  max-width: 85%;
  margin: 0 auto;
  background: #fff;
  @media (max-width: 720px) {
    background: none;
  }
`;
